import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="bd-libraire-picture"
//
// Uploads a picked file straight into CarrierWave's cache and writes the
// returned cache id into the `_cache` hidden field.
//
// Two reasons this cannot wait until the form is submitted: the live preview
// reloads its Turbo Frame through a GET, which a File cannot travel on, and
// any re-render (validation failure, swap confirmation) clears the file input
// so the selection would be lost silently. Caching on pick makes the pending
// image visible in the preview and lets `_cache` round-trip it.
export default class extends Controller {
  static targets = ["input", "cache", "thumb", "status"]
  static values = { url: String, model: String, column: String }

  cache() {
    const input = this.inputTarget
    if (!input.files || input.files.length === 0) return

    const body = new FormData()
    body.append("file", input.files[0])
    body.append("model", this.modelValue)
    body.append("column", this.columnValue)

    this.setStatus("Envoi en cours…")

    fetch(this.urlValue, {
      method: "POST",
      body: body,
      credentials: "same-origin",
      headers: { "X-CSRF-Token": this.csrfToken() }
    })
      .then((response) => {
        if (!response.ok) throw new Error("upload failed")
        return response.json()
      })
      .then((data) => {
        this.cacheTarget.value = data.cache_id
        if (this.hasThumbTarget && data.url) {
          this.thumbTarget.style.backgroundImage = "url(" + data.url + ")"
        }
        this.setStatus("")
        // The cache field now holds the pending upload, so the preview can
        // render it. Let the form controller reload the frame.
        this.element.dispatchEvent(
          new CustomEvent("bd-libraire-picture:cached", { bubbles: true })
        )
      })
      .catch(() => {
        this.setStatus("Échec de l'envoi, merci de réessayer.")
      })
  }

  setStatus(text) {
    if (this.hasStatusTarget) this.statusTarget.textContent = text
  }

  csrfToken() {
    const meta = document.querySelector("meta[name=csrf-token]")
    return meta ? meta.getAttribute("content") : ""
  }
}
